import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({
  size = "small",
  color = "white",
  label = "Loading",
}) => {
  return (
    <div
      className={`spinner ${size}`}
      style={{ borderColor: color, borderTopColor: "transparent" }}
      role="status"
      aria-label={label}
    />
  );
};

export default LoadingSpinner;
